<template>
  <div>
    <notifications group="foo" />
    <div
      v-if="this.$store.getters.isGeneralLoading"
      v-fullViewPort
      v-center
      class="vh-100"
    >
      <Loader width="1vw" height="31vh" v-center color="#fedd00" />
    </div>
    <router-view v-else />
  </div>
</template>

<script>
/* eslint-disable */
import Loader from "vue-spinner/src/BounceLoader.vue";

export default {
  name: "App",
  components: {
    Loader,
  },
  created() {
    const currentPath = this.$router.history.current.path;

    if (window.localStorage.getItem("t") === null) {
      this.$router.push("/login").catch((err) => {});
    }
    if (currentPath === "/" || currentPath === "/app") {
      //this.$store.dispatch('layout/setActiveTabAndOption', {tab: 'Excursions', option: 'Activity'})
      //this.$router.push("/app/excursiones/excursiones");
      this.$router.push("/app/dashboard");
    }
  },
};
</script>

<style src="./styles/theme.scss" lang="scss" />
